import React from "react";
import C from "../../../constants";
import { Tooltip as ReactTooltip } from "react-tooltip";

export default function RemoveIcon({
  fill = C.TERTIARY_COLOR_0,
  className = "",
  tooltipText = "Remove",
  onClick = undefined,
  ...props
}) {
  return (
    <React.Fragment>
      <div
        onClick={() => {
          if (onClick) {
            onClick();
          }
        }}
        style={{
          cursor: "pointer",
        }}
      >
        <svg
          width="20"
          height="20"
          viewBox="0 0 20 20"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
          className={className}
          data-tip
          data-for="remove-icon"
          {...props}
        >
          <path
            d="M15 8L14.1227 16.1414C14.0523 16.6341 13.6304 17 13.1327 17H6.8673C6.36964 17 5.94772 16.6341 5.87735 16.1414C5.87735 16.1414 5.34262 10.3984 5 8"
            stroke={fill}
            strokeWidth="2"
          />
          <path
            d="M3.5 5C3.5 5 7.43173 4 10 4C12.5683 4 16.5 5 16.5 5"
            stroke={fill}
            strokeWidth="2"
            strokeLinecap="round"
          />
          <path
            d="M9 3H11"
            stroke={fill}
            strokeWidth="2"
            strokeLinecap="round"
          />
        </svg>
      </div>

      <ReactTooltip id="remove-icon" place="top" className="tooltip-cls">
        {tooltipText}
      </ReactTooltip>
    </React.Fragment>
  );
}
